(function () {
  function visibleCount() {
    var width = window.innerWidth;
    if (width >= 750) return 4;
    if (width >= 600) return 3;
    if (width >= 480) return 2;
    return 1;
  }

  function cardStep(track) {
    var card = track.querySelector('.tasting-notes-serve__card');
    if (!card) return 0;
    var gap = parseFloat(window.getComputedStyle(track).gap) || 12;
    return card.getBoundingClientRect().width + gap;
  }

  function currentIndex(track) {
    var step = cardStep(track);
    if (step <= 0) return 0;
    return Math.round(track.scrollLeft / step);
  }

  function maxIndex(root) {
    var count = parseInt(root.getAttribute('data-serve-count'), 10) || 0;
    return Math.max(0, count - 1);
  }

  function updateControls(root) {
    var track = root.querySelector('[data-serve-track]');
    var dotsWrap = root.querySelector('[data-serve-dots]');
    var prev = root.querySelector('[data-serve-prev]');
    var next = root.querySelector('[data-serve-next]');
    if (!track) return;

    var index = currentIndex(track);
    var last = maxIndex(root);

    if (dotsWrap) {
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= last;
  }

  function scrollToIndex(root, index) {
    var track = root.querySelector('[data-serve-track]');
    if (!track) return;
    var last = maxIndex(root);
    var nextIndex = Math.max(0, Math.min(index, last));
    var step = cardStep(track);
    if (step <= 0) return;
    track.scrollTo({ left: nextIndex * step, behavior: 'smooth' });
  }

  function syncServe(root) {
    var track = root.querySelector('[data-serve-track]');
    var dotsWrap = root.querySelector('[data-serve-dots]');
    var arrowsWrap = root.querySelector('[data-serve-arrows]');
    if (!track) return;

    var count = parseInt(root.getAttribute('data-serve-count'), 10) || track.children.length;
    var visible = visibleCount();
    var isCarousel = count > visible;

    root.classList.toggle('tasting-notes-serve--carousel', isCarousel);
    root.setAttribute('data-serve-visible', String(visible));

    if (dotsWrap) dotsWrap.hidden = !isCarousel;
    if (arrowsWrap) arrowsWrap.hidden = !isCarousel;

    if (!isCarousel) {
      if (dotsWrap) dotsWrap.innerHTML = '';
      return;
    }

    if (dotsWrap && dotsWrap.childElementCount !== count) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i += 1) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'tasting-notes-serve__dot';
        button.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        button.setAttribute('data-serve-page', String(i));
        dotsWrap.appendChild(button);
      }
    }

    updateControls(root);
  }

  function bindServe(root) {
    var track = root.querySelector('[data-serve-track]');
    var dotsWrap = root.querySelector('[data-serve-dots]');
    var prev = root.querySelector('[data-serve-prev]');
    var next = root.querySelector('[data-serve-next]');
    if (!track) return;

    if (!root.dataset.serveReady) {
      if (dotsWrap) {
        dotsWrap.addEventListener('click', function (event) {
          var button = event.target.closest('[data-serve-page]');
          if (!button) return;
          scrollToIndex(root, parseInt(button.getAttribute('data-serve-page'), 10));
        });
      }
      if (prev) {
        prev.addEventListener('click', function () {
          scrollToIndex(root, currentIndex(track) - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollToIndex(root, currentIndex(track) + 1);
        });
      }
      track.addEventListener('scroll', function () {
        updateControls(root);
      }, { passive: true });
      root.dataset.serveReady = 'true';
    }

    syncServe(root);
  }

  function init() {
    document.querySelectorAll('[data-tasting-notes-serve]').forEach(bindServe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', init);
  document.addEventListener('shopify:section:load', init);
})();
